import ContentLoader from 'react-content-loader';

const WIDTH = 768;
const HEIGHT = 110;

const shapes = [
	{ x: 0, y: 0, w: 180, h: 42, r: 8 },
	{ x: 196, y: 0, w: 180, h: 42, r: 8 },
	{ x: 392, y: 0, w: 180, h: 42, r: 8 },
	{ x: 588, y: 0, w: 180, h: 42, r: 8 },
	{ x: WIDTH - 250, y: HEIGHT - 42, w: 250, h: 42, r: 8 },
];

function FiltersLoader({ isRtl }) {
	return (
		<div className="filters-loader">
			<ContentLoader role="status" width="100%" height={HEIGHT} viewBox={`0 0 ${WIDTH} ${HEIGHT}`} rtl={isRtl}>
				{shapes.map((s, i) => (
					<rect key={i} x={s.x} y={s.y} width={s.w} height={s.h} rx={s.r} ry={s.r} />
				))}
			</ContentLoader>
		</div>
	);
}

export default FiltersLoader;
